<template>
    <i aria-hidden="true" :class="className" :style="styles" :data-fa-transform="transforms" :data-fa-mask="maskIcon"></i>
</template>

<script>
    export default {
        name  : 'Icon',
        props : {
            name : {
                type     : String,
                required : true,
            },
            variant : {
                type     : String,
                required : false,
                validator(value) {
                    return [
                        'regular',
                        'solid',
                        'light',
                        'brand',
                        'duotone',
                    ].indexOf(value) !== -1
                },
                default : () => window.defaultIcons ? window.defaultIcons : `light`,
            },
            mask : {
                type     : String,
                required : false,
            },
            maskVariant : {
                type     : String,
                required : false,
                validator(value) {
                    return [
                        'regular',
                        'solid',
                        'light',
                        'brand',
                        'duotone',
                    ].indexOf(value) !== -1
                },
                default : () => window.defaultIcons ? window.defaultIcons : `solid`,
            },
            size : {
                type     : String,
                required : false,
                validator(value) {
                    return ['xs', 'sm', 'lg', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x',].indexOf(value) !== -1
                },
            },
            flip : {
                type     : String,
                required : false,
                validator(value) {
                    return ['v', 'h', 'both'].indexOf(value) !== -1
                },
            },
            pull : {
                type     : String,
                required : false,
                validator(value) {
                    return ['right', 'left'].indexOf(value) !== -1
                },
            },
            shrink : {
                type : Number,
                required : false,
            },
            grow : {
                type : Number,
                required : false,
            },
            up : {
                type : Number,
                required : false,
            },
            down : {
                type : Number,
                required : false,
            },
            right : {
                type : Number,
                required : false,
            },
            left : {
                type : Number,
                required : false,
            },
            rotate : {
                type : Number,
                required : false,
            },
            spin : {
                type : Boolean,
                required : false,
                default : false,
            },
            pulse : {
                type : Boolean,
                required : false,
                default : false,
            },
            inverse : {
                type : Boolean,
                required : false,
                default : false,
            },
            border : {
                type : Boolean,
                required : false,
                default : false,
            },
            fixedWidth : {
                type : Boolean,
                required : false,
                default : false,
            },
            swapOpacity : {
                type : Boolean,
                required : false,
                default : false,
            },
            primaryOpacity : {
                type     : Number,
                required : false,
                validator(value) {
                    return value >= 0 && value <= 1
                },
            },
            secondaryOpacity : {
                type     : Number,
                required : false,
                validator(value) {
                    return value >= 0 && value <= 1
                },
            },
            primaryColor : {
                type     : String,
                required : false,
            },
            secondaryColor : {
                type     : String,
                required : false,
            },
        },

        methods : {
            getClassVariant(variant) {
                switch (variant) {
                    case `solid`:
                        return `fas`
                        break
                    case `light`:
                        return `fal`
                        break
                    case `regular`:
                        return `far`
                        break
                    case `brand`:
                        return `fab`
                        break
                    case `duotone`:
                        return `fad`
                        break
                    default:
                        return `fal`
                        break
                }
            },

            getStyle(property, value, layer) {
                return value ? `--fa-${layer}-${property}:${value};` : ``
            },
        },

        computed : {
            classVariant() {
                return this.getClassVariant(this.variant)
            },
            maskClassVariant() {
                return this.getClassVariant(this.maskVariant)
            },
            styles() {
                let result = ``
                const properties = ['Opacity', 'Color']
                properties.forEach(property => {
                    ['primary', 'secondary'].forEach(layer => {
                        result += this.getStyle(
                            property.toLowerCase(),
                            this[`${layer}${property}`],
                            layer
                        )
                    })
                })
                return result
            },
            transforms() {
                const shrink = this.shrink ? `shrink-${this.shrink}` : ``
                const grow = this.grow ? `grow-${this.grow}` : ``
                const up = this.up ? `up-${this.up}` : ``
                const down = this.down ? `down-${this.down}` : ``
                const right = this.right ? `right-${this.right}` : ``
                const left = this.left ? `left-${this.left}` : ``
                const rotate = this.rotate ? `rotate-${this.rotate}` : ``
                let flip = ``
                if (this.flip) {
                    flip = this.flip === 'both' ? `flip-v flip-h` : `flip-${this.flip}`
                }
                return `${shrink} ${grow} ${up} ${down} ${right} ${left} ${rotate} ${flip}`.trim()
            },
            className() {
                const border = this.border ? `fa-border` : ``
                const spin = this.spin ? `fa-spin` : ``
                const pulse = this.pulse ? `fa-pulse` : ``
                const inverse = this.inverse ? `fa-inverse` : ``
                const fixedWidth = this.fixedWidth ? `fa-fw` : ``
                const size = this.size ? `fa-${this.size}` : ``
                const pull = this.pull ? `fa-pull-${this.pull}` : ``
                const swapOpacity = this.swapOpacity ? `fa-swap-opacity` : ``

                return `${this.classVariant} fa-${this.name} ${spin} ${pulse} ${inverse} ${size} ${fixedWidth} ${border} ${pull} ${swapOpacity}`.trim()
            },
            maskIcon() {
                return this.mask ? `${this.maskClassVariant} fa-${this.mask}` : null
            },
        },
    }
</script>
